import React from 'react';
import './CustomButton.scss';

interface CustomButtonProps {
    additionalStyle?: string | null;
    isDisabled?: boolean;
    isBordered?: boolean;
    title?: string;
    onClick: () => void;
    children?: React.ReactElement;
}

export const CustomButton = ({
    title,
    isBordered = false,
    isDisabled = false,
    onClick,
    additionalStyle,
    children,
}: CustomButtonProps): React.ReactElement => {
    const className = [
        'CustomButton-Default',
        isBordered ? 'CustomButton-Bordered' : 'CustomButton-Plain',
        additionalStyle || '',
        isDisabled ? 'CustomButton-Disabled' : '',
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <button disabled={isDisabled} className={className} onClick={onClick}>
            {title || children}
        </button>
    );
};
